import { render, staticRenderFns } from "./CrazyRescueDetail.vue?vue&type=template&id=00710ad3&"
import script from "./CrazyRescueDetail.vue?vue&type=script&lang=js&"
export * from "./CrazyRescueDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports